module.exports = __webpack_public_path__ + "static/media/_edit (2).62806dce.svg";